import React from "react";
import { AreaChart,Area,XAxis,YAxis,Tooltip,ResponsiveContainer } from "recharts";
function fmt(n){if(!n)return"$0";if(n>=1e9)return`$${(n/1e9).toFixed(2)}B`;if(n>=1e6)return`$${(n/1e6).toFixed(1)}M`;return`$${(n/1e3).toFixed(0)}K`;}
const EC={binance:"#f59e0b",bybit:"#3b82f6",okx:"#a855f7",hyperliquid:"#22c55e"};
export default function OIPanel({ data }) {
  if (!data) return <p style={{color:"#6b7280"}}>데이터 없음</p>;
  const {exchanges={},total_usd=0,history=[]} = data;
  const cd = history.map(h=>({ts:h.ts,oi:h.oi}));
  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <div style={{display:"flex",alignItems:"baseline",gap:10}}>
        <span style={{fontSize:26,fontWeight:700}}>{fmt(total_usd)}</span>
        <span style={{fontSize:13,color:"#6b7280"}}>전체 OI 합산</span>
      </div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        {Object.entries(exchanges).map(([ex,d])=>(
          <div key={ex} style={{padding:"6px 12px",borderRadius:8,background:"#181c24",
            border:`1px solid ${EC[ex]||"#333"}44`}}>
            <span style={{fontSize:11,fontWeight:700,textTransform:"capitalize",color:EC[ex]||"#aaa"}}>{ex}</span>
            <span style={{fontSize:13,fontWeight:600,marginLeft:8}}>{fmt(d.oi_usd)}</span>
          </div>
        ))}
      </div>
      {cd.length>1&&(
        <ResponsiveContainer width="100%" height={150}>
          <AreaChart data={cd}>
            <defs><linearGradient id="og" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#22c55e" stopOpacity={0.3}/>
              <stop offset="95%" stopColor="#22c55e" stopOpacity={0}/>
            </linearGradient></defs>
            <XAxis dataKey="ts" tick={{fill:"#4b5563",fontSize:10}} axisLine={false} tickLine={false}
              tickFormatter={v=>new Date(v).toLocaleTimeString("ko-KR",{hour:"2-digit",minute:"2-digit"})}
              interval={Math.floor(cd.length/6)}/>
            <YAxis tick={{fill:"#4b5563",fontSize:10}} axisLine={false} tickLine={false} width={60}
              tickFormatter={v=>fmt(v)}/>
            <Tooltip contentStyle={{background:"#181c24",border:"1px solid #1e2433",borderRadius:8,fontSize:11}}
              formatter={v=>[fmt(v),"OI"]}/>
            <Area type="monotone" dataKey="oi" stroke="#22c55e" strokeWidth={1.5} fill="url(#og)"/>
          </AreaChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
